export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  const sameAs = [
    config.public.faceBookUrl,
    config.public.instagramUrl,
    config.public.telegramLink,
  ].filter((url): url is string => typeof url === "string" && url.length > 0);

  const ld = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://georgiadream.ge/#organization",
        name: "Dreamland Oasis Chakvi Apartments",
        alternateName: "Georgia Dream",
        url: "https://georgiadream.ge/",
        logo: {
          "@type": "ImageObject",
          url: "https://georgiadream.ge/logo.png",
        },
        email: config.public.contactEmail || "info@georgiadream.ge",
        telephone: (config.public.whatsappNumber as string) || "+995505556117",
        address: {
          "@type": "PostalAddress",
          streetAddress: "Batumi st. 16",
          addressLocality: "Chakvi",
          addressRegion: "Adjara",
          postalCode: "6200",
          addressCountry: "GE",
        },
        ...(sameAs.length ? { sameAs } : {}),
      },
      {
        "@type": "WebSite",
        "@id": "https://georgiadream.ge/#website",
        url: "https://georgiadream.ge/",
        name: "Dreamland Oasis Chakvi",
        publisher: { "@id": "https://georgiadream.ge/#organization" },
        inLanguage: ["en", "ru", "ka"],
      },
    ],
  };

  useHead({
    script: [
      {
        type: "application/ld+json",
        innerHTML: JSON.stringify(ld),
      },
    ],
  });
});
